import { AbstractDTO } from "./abstract";

export class DataTableRequest extends AbstractDTO{
    sort: string;
    order: string;
    pageIndex: number;
    search: string;
    unlink: boolean;
    limit: number;
    parentProductCngId: number;
    cngId: number;
    fields: [];
    filters: any;
    mainScreenCngId: number;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.sort = attributes['sort'] || false;
        this.order = attributes['order'] || false;
        this.pageIndex = attributes['pageIndex'] || false;
        this.search = attributes['search'] || false;
        this.limit = attributes['limit'] || false;
        this.unlink = attributes['unlink'] || false;
        this.parentProductCngId = attributes['parentProductCngId'] || false;
        this.cngId = attributes['cngId'] || false;
        this.fields = attributes['fields'] || [];
        this.filters = attributes['filters'] || null;
    }
}
